import { isEditableOrControlTarget } from './isEditableOrControlTarget'

// Shared pin-reposition key contract (map Move-Pin + form Precise Location): Esc cancels,
// Enter confirms, typing targets keep their keys, and it defers to already-handled events.
export function createPinMoveKeyHandler(opts: {
  isActive: () => boolean
  onCancel: () => void
  onDone: () => void
}): (e: KeyboardEvent) => void {
  return e => {
    if (!opts.isActive() || (e.key !== 'Escape' && e.key !== 'Enter')) {
      return
    }
    if (e.defaultPrevented || isEditableOrControlTarget(e.target)) {
      return
    }
    e.preventDefault()
    if (e.key === 'Enter') {
      opts.onDone()
    } else {
      opts.onCancel()
    }
  }
}
